import React from 'react';

// This component renders the provided SVG for an elevator.
// It accepts a className prop to allow for external styling.
export const ElevatorIcon = ({ className }: { className?: string }) => {
  return (
    <svg 
      version="1.1" 
      id="Layer_1" 
      xmlns="http://www.w3.org/2000/svg" 
      xmlnsXlink="http://www.w3.org/1999/xlink" 
      viewBox="0 0 100 100" 
      enableBackground="new 0 0 100 100" 
      xmlSpace="preserve"
      className={className}
    >
      <g>
        <path d="M77.741,10.79c-0.001,0-0.001,0-0.002,0v0H4.36v0c-1.391,0.001-2.519,1.129-2.519,2.521V86.69
          c0,1.391,1.128,2.52,2.519,2.521l0,0h0.001c0,0,0,0,0.001,0s0,0,0.001,0h73.376l0,0c0.001,0,0.001,0,0.002,0
          c1.393,0,2.521-1.129,2.521-2.521V13.311C80.262,11.918,79.134,10.79,77.741,10.79z M11.862,20.809h58.381V79.19H11.862V20.809z"/>
        <path d="M97.524,63.966h-2.882l0-7.737c0-0.33-0.266-0.596-0.595-0.596h-5.333c-0.329,0-0.595,0.266-0.595,0.596
          v7.736h-2.883c-0.223,0.001-0.427,0.126-0.529,0.324c-0.103,0.197-0.085,0.437,0.045,0.618l6.164,8.616
          c0.111,0.156,0.292,0.248,0.483,0.248c0.001,0,0.001,0,0.001,0c0.193,0,0.373-0.094,0.484-0.25l6.125-8.615
          c0.129-0.182,0.146-0.421,0.043-0.619C97.952,64.09,97.747,63.965,97.524,63.966z"/>
        <path d="M85.276,36.035h2.882l0,7.737c0,0.329,0.267,0.595,0.596,0.596l5.333-0.001
          c0.329,0,0.596-0.266,0.595-0.595v-7.737h2.883c0.223,0,0.427-0.125,0.529-0.323s0.085-0.438-0.045-0.618l-6.164-8.615
          c-0.112-0.157-0.292-0.25-0.483-0.25c-0.001,0-0.001,0-0.001,0c-0.193,0.002-0.373,0.094-0.485,0.252l-6.124,8.614
          c-0.129,0.181-0.146,0.42-0.044,0.618C84.848,35.91,85.053,36.035,85.276,36.035z"/>
        <circle cx="27.998" cy="31.993" r="4.955"/>
        <path d="M37.38,38.28v-0.024H19.628v0.017c-1.283,0-2.323,1.036-2.332,2.316h-0.002v14.04h0.023
          c-0.001,0.535,0.202,1.07,0.61,1.478c0.813,0.814,2.133,0.814,2.947,0c0.407-0.408,0.61-0.943,0.609-1.478h0.005v-9.699v-0.103
          h0.006c0.015-0.354,0.302-0.638,0.66-0.638c0.358,0,0.646,0.283,0.661,0.638h0.006v0.103v6.254v19.344
          c0.002,1.345,1.091,2.434,2.437,2.434c1.345,0,2.437-1.091,2.437-2.437V57.584h0.018c0-0.373,0.302-0.675,0.675-0.675
          s0.675,0.302,0.675,0.675h0.017v12.941c0,1.346,1.092,2.437,2.437,2.437c1.346,0,2.437-1.091,2.437-2.437V57.584v-6.399v-6.254
          v-0.103c0-0.369,0.298-0.667,0.666-0.667c0.367,0,0.665,0.298,0.665,0.667v0.103v9.699h0.023c-0.001,0.535,0.202,1.07,0.61,1.478
          c0.814,0.814,2.133,0.814,2.947,0c0.408-0.408,0.611-0.943,0.61-1.478h0.004v-14.04C39.477,39.383,38.556,38.401,37.38,38.28z"/>
        <circle cx="53.331" cy="31.993" r="4.955"/>
        <path d="M62.713,38.28v-0.024H44.961v0.017c-1.283,0-2.323,1.036-2.332,2.316h-0.002v14.04h0.023
          c-0.001,0.535,0.202,1.07,0.61,1.478c0.813,0.814,2.133,0.814,2.947,0c0.407-0.408,0.61-0.943,0.609-1.478h0.005v-9.699v-0.103
          h0.006c0.015-0.354,0.302-0.638,0.66-0.638c0.358,0,0.646,0.283,0.661,0.638h0.006v0.103v6.254v19.344
          c0.002,1.345,1.091,2.434,2.437,2.434c1.345,0,2.437-1.091,2.437-2.437V57.584h0.018c0-0.373,0.302-0.675,0.675-0.675
          s0.675,0.302,0.675,0.675h0.017v12.941c0,1.346,1.092,2.437,2.437,2.437c1.346,0,2.437-1.091,2.437-2.437V57.584v-6.399v-6.254
          v-0.103c0-0.369,0.298-0.667,0.666-0.667c0.367,0,0.665,0.298,0.665,0.667v0.103v9.699h0.023c-0.001,0.535,0.202,1.07,0.61,1.478
          c0.814,0.814,2.133,0.814,2.947,0c0.408-0.408,0.611-0.943,0.61-1.478h0.004v-14.04C64.809,39.383,63.889,38.401,62.713,38.28z"/>
      </g>
    </svg>
  );
};